import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { UserService } from './../../services/user.service';
import { CommonService } from './../../services/common.service';
import { EncrDecrService } from './../../services/encr-decr.service';


@Component({
  selector: 'app-s-edit-user',
  templateUrl: './s-edit-user.component.html',
  styleUrls: ['./s-edit-user.component.css']
})
export class SEditUserComponent implements OnInit {
  user_id:any=0;
  company_id:any=0;
  APIKEY:any=0;
  editUserForm: FormGroup;
  submitted = false;
  check_per_mode:boolean=false;
  customer_list_event:boolean=false;
  edit_userid:number=0;
  role_list:any='';
  selectedItems:any = {};
  customer_per:any='';
  dropdownSettings = {};
  dropdownList = [];
  user_comapny_id:any=0;
  roleMode:any=false;

  constructor(private formBuilder: FormBuilder,
    private _User:UserService,
    private toastr: ToastrService,
    private _Common:CommonService,
    private _router : Router,
    private EncrDecr: EncrDecrService,
    private _activatedroute: ActivatedRoute,) { }

    getUserCustomer(id,mode){
      const data= {
        APIKEY : this.APIKEY,
        edit_userid : id,
        company_id : this.company_id,

      }


      this._User.getUserCustomer(data)
      .subscribe(
        res => {
            if(mode=='custper'){
              this.selectedItems=res.data;
            }
           },
      );
     }

  ngOnInit() {
    this.user_id =localStorage.getItem('id');
    this.company_id =localStorage.getItem('company_id');
    this.APIKEY =localStorage.getItem('APIKEY');

    this.setFormValue();

    this._activatedroute.params.subscribe(params => {
      this.edit_userid = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
    });

    // this._activatedroute.params.subscribe(params => {
    //   this.edit_userid = params['id'];
    // });
    this.getUserCustomer(this.edit_userid,'custper');

    const data= {
      APIKEY : this.APIKEY,
      edit_userid : this.edit_userid,
      company_id : this.company_id,
    }

    const roledata= {
      APIKEY : this.APIKEY,
      company_id : this.company_id,
    }

   // alert(this.company_id);

    this._User.getUserInfo(data)
    .subscribe( res => {
        // console.log(res.data);
        this.user_comapny_id=res.data.company_id;
        const roleData= {
          APIKEY : this.APIKEY,
          edit_userid : this.edit_userid,
          company_id : this.user_comapny_id,
        }
        //console.log(roleData);

         this.getRoleList(roleData);

         this.editUserForm.get('alter_phone').setValue(res.data.alter_phone);
         this.editUserForm.get('email').setValue(res.data.email);
         this.editUserForm.get('first_name').setValue(res.data.first_name);
         this.editUserForm.get('id').setValue(res.data.id);
         this.editUserForm.get('last_name').setValue(res.data.last_name);
         this.editUserForm.get('note').setValue(res.data.note);
         this.editUserForm.get('password').setValue(this.EncrDecr.get(localStorage.getItem('key'), res.data.password));
         //this.editUserForm.get('password').setValue(res.data.password);
         this.editUserForm.get('phone').setValue(res.data.phone);
         this.editUserForm.get('role').setValue(res.data.role);
         this.editUserForm.get('status').setValue(res.data.status);

         if(res.data.urole_type=='CompanyAdmin'){


         }

         console.log(this.roleMode);


      var role_name=res.data.role;
      var splitrole_name = role_name.split("-", 3);
      // if(splitrole_name[1]=='Mobile User'){this.customer_list_event=true;}
      if(splitrole_name[1]=='Sales Person'){this.customer_list_event=true;}

      if(res.data.customer_per=='all'){
        this.check_per_mode= true;
      }

    });
    this.getCustomerListDrop();
    this.getCustomerListadmin({user_id:this.user_id,APIKEY:this.APIKEY},'normal');

  }



  public onCustomerPer(value:boolean){
    if(value!=true){
      this.selectedItems = [];
      this.customer_per='';
    }
    else{
      const data= {
        APIKEY : this.APIKEY,
        company_id : this.company_id,
      }
      const mode='custper';
      this.getCustomerListadmin(data,mode);
      this.customer_per='all';
    }
}

// getCustomerLis(data,mode){
//   this._Common.getCustomerList(data)
//   .subscribe(
//     res => {
//     //  console.log(res);
//         if(mode=='custper'){
//           this.selectedItems=res.data;
//         }
//         this.dropdownList=res.data;
//       },
//   );
//  }
 getCustomerListDrop(){
  this.dropdownSettings = {
    singleSelection: false,
    enableCheckAll:false,
    idField: 'c_id',
    textField: 'company_name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };
 }

 getRoleList(data){
  this._Common.getRoleList(data)
   .subscribe(
     res => {
   //   console.log(res);
      this.role_list=res.data;
     },
   );
 }

  setFormValue(){
    this.editUserForm = this.formBuilder.group({
        first_name: ['', Validators.required],
        last_name: [''],
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.minLength(6)]],
        phone: [''],
        alter_phone: [''],
        role: [{value: '', disabled: false}, Validators.required],
        note: [''],
        company_id: [''],
        status: ['active'],
        id: ['0'],

    });
  }




  // convenience getter for easy access to form fields
  get f() { return this.editUserForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.editUserForm.invalid) {
          return;
    }

    //alert('SUCCESS!! :-)')
    const formData = new FormData();
    formData.append('first_name', this.editUserForm.get('first_name').value);
    formData.append('last_name', this.editUserForm.get('last_name').value);
    formData.append('email', this.editUserForm.get('email').value);
    formData.append('password', this.EncrDecr.set(localStorage.getItem('key'), this.editUserForm.get('password').value));
    //formData.append('password', this.editUserForm.get('password').value);
    formData.append('phone', this.editUserForm.get('phone').value);
    formData.append('alter_phone', this.editUserForm.get('alter_phone').value);
    formData.append('note', this.editUserForm.get('note').value);
    formData.append('id', this.editUserForm.get('id').value);
    formData.append('role', this.editUserForm.get('role').value);
    formData.append('status', this.editUserForm.get('status').value);
    formData.append('user_id', this.user_id);
    formData.append('company_id', this.company_id);
    formData.append('APIKEY', this.APIKEY);
    formData.append('customer_list', JSON.stringify(this.selectedItems));

//console.log(formData); return false;
    this._User.updateUSer(formData).subscribe(
        res => {
         // console.log(res); return false;
          if(res.status==true){  //return false;
             this.toastr.success(res.message, 'Success');
             //this. ngOnInit();
             this._router.navigateByUrl('/redirect').then(() => {
              this._router.navigateByUrl('/super-admin/user-list');
             });

          }
          else{
             this.toastr.error(res.message, 'Error');
          }
        }
    );
}



  public onChangeRole(event): void {  // event will give you full breif of action
    const newVal = event.target.value;
    var splitted = newVal.split("-", 3);
    var name= splitted[1];
    if(name==='Mobile User'){
        this.customer_list_event=true;
    }
    else{
        this.customer_list_event=false;
    }
  }
  getCustomerListadmin(data,mode){
    this._Common.getCustomerListsuperadmin(data)
    .subscribe(
      res => {
          if(mode=='custper'){
            this.selectedItems=res.data;
          }
          this.dropdownList=res.data;
        },
    );}

  public onChange(event): void {
     // event will give you full breif of action
    const newVal = event.target.value;
    if(newVal=='431'){
        this.customer_list_event=true;
    }
    else{
        this.customer_list_event=false;
    }

  }

}
